import {alpha as fade} from '@material-ui/core/styles';

const variants = ['text', 'outlined', 'contained'];
const colors = ['error', 'warning', 'info', 'success', 'gray'];

const isOutlined = (variant) => variant === variants[1];
const isContained = (variant) => variant === variants[2];

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function template(variant, color, theme) {
  return {
    ...{
      color: theme.palette[color].main,
    },
    ...(isContained(variant) && {
      color: theme.palette[color].contrastText,
      backgroundColor: theme.palette[color].main,
    }),
    ...(isOutlined(variant) && {
      border: '1px solid',
      borderColor: fade(theme.palette[color].main, 0.5),
    }),
    ...{
      '&:hover': {
        ...{
          backgroundColor: fade(
            theme.palette[color].main,
            theme.palette.action.hoverOpacity,
          ),
        },
        ...(isContained(variant) && {
          backgroundColor: theme.palette[color].dark,
        }),
        ...(isOutlined(variant) && {
          border: '1px solid',
          borderColor: theme.palette[color].main,
        }),
        ...{
          // reset on touch devices
          '@media (hover: none)': {
            ...(isContained(variant) && {
              backgroundColor: theme.palette[color].main,
            }),
            ...(!isContained(variant) && {
              backgroundColor: 'transparent',
            }),
          },
        },
      },
    },
  };
}

export function createButtonStyles(theme) {
  const style = {};

  for (const variant of variants) {
    for (const color of colors) {
      style[variant + capitalize(color)] = template(variant, color, theme);
    }
  }

  return style;
}
